const styles = theme => ({
  wrapper: {
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    background: "none",
    border: "none",
    outline: "none",
  },
  icon: {
    cursor: "pointer",
  },
  progress: {},
})

export default styles
